// 수신자료관리 - 기초관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const REP01 = lazy(() => import('@/pages/B01/REP01'));  // 자료생성(수동)
const RNT30 = lazy(() => import('@/pages/B01/RNT30'));  // Body seq 219 코드등록

function B01() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B01/REP01" component={REP01} />
        <Route path="/B01/RNT30" component={RNT30} />
      </Switch>
    </Suspense>
  );
}

export default B01;
